// extracted by mini-css-extract-plugin
export default {"addToCartControl":"o2-z","giftCard":"p2-z","btnContainer":"q2-z","cartButton":"r2-z","disabled":"s2-z"};